"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeLink = void 0;
const getThemeLink = (partnername, customname) => partnername && customname && `/${partnername}/${customname}-config.json`;
exports.getThemeLink = getThemeLink;
